export default __webpack_public_path__ + "static/media/Curvet6.3.071b22de.svg";